export const API_URL = 'https://lr-calculation-engine.azurewebsites.net/api';
